import { makeStyle } from '../../../../utils';
import { blackHigh, subTitle2 } from '../../../../resources/styles';
import view from '../../../../Enums';


const styles = {};

styles['earning'] = makeStyle({
    ...subTitle2,
    ...blackHigh,
    cursor: 'pointer',
    display: 'none',
}, { display: 'block', marginRight:24 },{marginRight: 18},view.TAB);

styles['popper'] = makeStyle({
    zIndex: 1000 , marginRight: 12,backgroundColor:'white',marginTop:18,width:'330px',boxShadow: 'var(--shadow)',
    borderRadius:'6px',padding:'0px 2px'
});

export default styles;